export class TableColumnModel {
  constructor(id, label, minWidth, sortable, isAction) {
    this.id = id;
    this.label = label;
    this.minWidth = minWidth;
    this.sortable = sortable;
    this.isAction = isAction;
  }
}
